import { Badge } from "@holigral/shared/ui/components/ui/badge"
import { useT } from "@/i18n"

type Props = {
  readonly balance: number
}

export default function CreditBalanceBadge({ balance }: Props) {
  const { t } = useT("money")

  return <Badge variant="tag">{t("balance.credits", { count: balance })}</Badge>
}
